export default __webpack_public_path__ + "images/RVP.21edf32.png";